import React from 'react';
import { Input } from './ui/input';
import { Label } from './ui/label';

export function VInput({ label, unit, v, on, testid, step }) {
  return (
    <div>
      <Label className="text-xs font-semibold text-zinc-700">
        {label} <span className="text-zinc-400 font-normal">({unit})</span>
      </Label>
      <Input
        type="number"
        step={step || '1'}
        value={v ?? ''}
        onChange={(e) => on(e.target.value)}
        data-testid={testid}
        className="h-9 text-sm"
      />
    </div>
  );
}

export function BP({ value, onChange }) {
  return (
    <div className="col-span-2">
      <Label className="text-xs font-semibold text-zinc-700">
        BP <span className="text-zinc-400 font-normal">(mmHg)</span>
      </Label>
      <div className="flex items-center gap-1.5">
        <Input
          type="number"
          value={value.bp_systolic ?? ''}
          onChange={(e) => onChange('bp_systolic', e.target.value)}
          className="h-9 text-sm"
          placeholder="Systolic"
          data-testid="t-bp-sys"
        />
        <span className="text-zinc-400 font-bold">/</span>
        <Input
          type="number"
          value={value.bp_diastolic ?? ''}
          onChange={(e) => onChange('bp_diastolic', e.target.value)}
          className="h-9 text-sm"
          placeholder="Diastolic"
          data-testid="t-bp-dia"
        />
      </div>
    </div>
  );
}
